import ICONS_DEFAULT_MAP from './icons/default/index';
import ICONS_FLAGS_MAP from './icons/flags/index';
import ILLUSTRATIONS_MAP from './illustrations/index';

// Spacing
export const PRISM_SPACING_50 = 2;
export const PRISM_SPACING_100 = 4;
export const PRISM_SPACING_200 = 8;
export const PRISM_SPACING_300 = 12;
export const PRISM_SPACING_400 = 16;
export const PRISM_SPACING_500 = 20;
export const PRISM_SPACING_600 = 24;
export const PRISM_SPACING_700 = 28;
export const PRISM_SPACING_800 = 32;
export const PRISM_SPACING_900 = 36;
export const PRISM_SPACING_1000 = 40;

// Icons
export { ICONS_DEFAULT_MAP, ICONS_FLAGS_MAP };

// Icon and Illustration Types
export type { IconName } from './icons/default/index';
export type { IconFlagCode } from './icons/flags/index';

// Illustrations
export { ILLUSTRATIONS_MAP };

export type { IllustrationName } from './illustrations/index';

// TIMING
export const TOAST_TIMEOUT_SHORT = 3000;
export const TOAST_TIMEOUT_LONG = 8000;
